var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wkb-edge-inspector-stack" },
    [
      _c("section", { staticClass: "wkb-inspector-panel-block" }, [
        _c("h3", { staticClass: "wkb-inspector-node-title" }, [
          _vm._v(_vm._s(_vm.edgeLabel)),
        ]),
        _vm.hasMeta
          ? _c("dl", { staticClass: "wkb-inspector-meta" }, [
              _vm.selectedEdge.edgeType
                ? _c("div", [
                    _c("dt", [_vm._v("Type")]),
                    _c("dd", [_vm._v(_vm._s(_vm.selectedEdge.edgeType))]),
                  ])
                : _vm._e(),
              _vm.selectedEdge.isContextual
                ? _c("div", [
                    _c("dt", [_vm._v("Role")]),
                    _c("dd", [_vm._v("Contextual edge")]),
                  ])
                : _vm._e(),
              _vm.selectedEdge.scoreLabel
                ? _c("div", [
                    _c("dt", [_vm._v("Score")]),
                    _c("dd", [_vm._v(_vm._s(_vm.selectedEdge.scoreLabel))]),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _vm.provenanceLoading
        ? _c("p", { staticClass: "wkb-inspector-note" }, [
            _vm._v("Loading edge provenance…"),
          ])
        : _vm.provenanceError
        ? _c(
            "p",
            { staticClass: "wkb-inspector-note wkb-inspector-note--warn" },
            [_vm._v(" " + _vm._s(_vm.provenanceError) + " ")]
          )
        : _vm.payload
        ? [
            _vm.payload.relation === "gene_trait"
              ? _c(
                  "section",
                  { staticClass: "wkb-inspector-panel-block" },
                  [
                    _c("h4", { staticClass: "wkb-inspector-section-heading" }, [
                      _vm._v(_vm._s(_vm.payload.title)),
                    ]),
                    _vm.payload.summary
                      ? _c("p", { staticClass: "wkb-inspector-note" }, [
                          _vm._v(_vm._s(_vm.payload.summary)),
                        ])
                      : _vm._e(),
                    _vm.payload.provenance_note
                      ? _c("p", { staticClass: "wkb-inspector-note" }, [
                          _vm._v(
                            " " + _vm._s(_vm.payload.provenance_note) + " "
                          ),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "wkb-edge-provenance-grid" },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "h5",
                              { staticClass: "wkb-edge-provenance-subheading" },
                              [_vm._v("Genetic support")]
                            ),
                            _c(
                              "p",
                              { staticClass: "wkb-edge-provenance-line" },
                              [
                                _c("strong", [_vm._v("Combined probability:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatProbability(
                                        _vm.payload.direct_support
                                          ?.combined_score
                                      )
                                    ) +
                                    " "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "wkb-inspector-note" },
                                  [
                                    _vm._v(
                                      " (logBF " +
                                        _vm._s(
                                          _vm.formatValue(
                                            _vm.payload.direct_support
                                              ?.combined_score,
                                            2
                                          )
                                        ) +
                                        ") "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "p",
                              { staticClass: "wkb-edge-provenance-line" },
                              [
                                _c("strong", [_vm._v("Direct probability:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatProbability(
                                        _vm.payload.direct_support?.direct_score
                                      )
                                    ) +
                                    " "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "wkb-inspector-note" },
                                  [
                                    _vm._v(
                                      " (logBF " +
                                        _vm._s(
                                          _vm.formatValue(
                                            _vm.payload.direct_support
                                              ?.direct_score,
                                            2
                                          )
                                        ) +
                                        ") "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "p",
                              { staticClass: "wkb-edge-provenance-line" },
                              [
                                _c("strong", [_vm._v("Indirect probability:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatProbability(
                                        _vm.payload.direct_support
                                          ?.indirect_score
                                      )
                                    ) +
                                    " "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "wkb-inspector-note" },
                                  [
                                    _vm._v(
                                      " (logBF " +
                                        _vm._s(
                                          _vm.formatValue(
                                            _vm.payload.direct_support
                                              ?.indirect_score,
                                            2
                                          )
                                        ) +
                                        ") "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c("WorkspaceLeadSnpSummary", {
                              attrs: {
                                "direct-support": _vm.payload.direct_support,
                              },
                            }),
                          ],
                          1
                        ),
                        _c("WorkspaceGeneTraitLocusZoomPane", {
                          attrs: {
                            "locus-zoom": _vm.locusZoomPayload,
                            "api-client": _vm.apiClient,
                          },
                        }),
                      ],
                      1
                    ),
                    _c("WorkspaceEvidenceTable", {
                      attrs: {
                        title:
                          "Top gene sets containing the gene for this trait",
                        rows: _vm.visibleIndirectGeneSetRows,
                        columns: _vm.indirectGeneSetColumns,
                        "page-size": 5,
                        "empty-note": _vm.indirectGeneSetEmptyNote,
                        "pagination-label": "Gene set pages",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "controls",
                            fn: function () {
                              return [
                                _c(
                                  "label",
                                  { staticClass: "wkb-edge-provenance-toggle" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.showCfdeOnly,
                                          expression: "showCfdeOnly",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(_vm.showCfdeOnly)
                                          ? _vm._i(_vm.showCfdeOnly, null) > -1
                                          : _vm.showCfdeOnly,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.showCfdeOnly,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.showCfdeOnly = $$a.concat([
                                                  $$v,
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.showCfdeOnly = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.showCfdeOnly = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" Show CFDE only "),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "addGeneSet",
                            fn: function ({ row }) {
                              return [
                                _vm.isGeneSetOnGraph(row)
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "wkb-inspector-mini-btn wkb-inspector-mini-btn--remove",
                                        attrs: {
                                          type: "button",
                                          disabled: _vm.graphBusy,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onRemoveGeneSet(row)
                                          },
                                        },
                                      },
                                      [_vm._v(" Remove ")]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass:
                                          "wkb-inspector-mini-btn wkb-inspector-mini-btn--add",
                                        attrs: {
                                          type: "button",
                                          disabled: _vm.graphBusy,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onAddGeneSet(row)
                                          },
                                        },
                                      },
                                      [_vm._v(" Add ")]
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        194118928
                      ),
                    }),
                  ],
                  1
                )
              : _vm.payload.relation === "gene_factor"
              ? _c(
                  "section",
                  { staticClass: "wkb-inspector-panel-block" },
                  [
                    _c("h4", { staticClass: "wkb-inspector-section-heading" }, [
                      _vm._v(_vm._s(_vm.payload.title)),
                    ]),
                    _vm.payload.summary
                      ? _c("p", { staticClass: "wkb-inspector-note" }, [
                          _vm._v(_vm._s(_vm.payload.summary)),
                        ])
                      : _vm._e(),
                    _vm.payload.provenance_note
                      ? _c("p", { staticClass: "wkb-inspector-note" }, [
                          _vm._v(
                            " " + _vm._s(_vm.payload.provenance_note) + " "
                          ),
                        ])
                      : _vm._e(),
                    _c("p", { staticClass: "wkb-edge-provenance-line" }, [
                      _c("strong", [_vm._v("Gene loading:")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatValue(
                              _vm.payload.gene_loading?.loading,
                              3
                            )
                          ) +
                          " "
                      ),
                    ]),
                    _c("p", { staticClass: "wkb-edge-provenance-line" }, [
                      _c("strong", [_vm._v("Normalized score:")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatValue(
                              _vm.payload.gene_loading?.normalized_score,
                              3
                            )
                          ) +
                          " "
                      ),
                    ]),
                    _c("WorkspaceEvidenceTable", {
                      attrs: {
                        title:
                          "Gene sets containing the gene with highest factor loadings",
                        rows: _vm.payload.supporting_gene_sets || [],
                        columns: _vm.supportingGeneSetColumns,
                        "empty-note": _vm.geneFactorGeneSetEmptyNote,
                        "pagination-label": "Gene set pages",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "addGeneSet",
                          fn: function ({ row }) {
                            return [
                              _vm.isGeneSetOnGraph(row)
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "wkb-inspector-mini-btn wkb-inspector-mini-btn--remove",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.graphBusy,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onRemoveGeneSet(row)
                                        },
                                      },
                                    },
                                    [_vm._v(" Remove ")]
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass:
                                        "wkb-inspector-mini-btn wkb-inspector-mini-btn--add",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.graphBusy,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onAddGeneSet(row)
                                        },
                                      },
                                    },
                                    [_vm._v(" Add ")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                )
              : _vm.payload.relation === "factor_trait"
              ? _c(
                  "section",
                  { staticClass: "wkb-inspector-panel-block" },
                  [
                    _c("h4", { staticClass: "wkb-inspector-section-heading" }, [
                      _vm._v(_vm._s(_vm.payload.title)),
                    ]),
                    _vm.payload.summary
                      ? _c("p", { staticClass: "wkb-inspector-note" }, [
                          _vm._v(_vm._s(_vm.payload.summary)),
                        ])
                      : _vm._e(),
                    _vm.payload.provenance_note
                      ? _c("p", { staticClass: "wkb-inspector-note" }, [
                          _vm._v(
                            " " + _vm._s(_vm.payload.provenance_note) + " "
                          ),
                        ])
                      : _vm._e(),
                    _c("p", { staticClass: "wkb-edge-provenance-line" }, [
                      _c("strong", [_vm._v("Family:")]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.payload.factor_relevance?.family || "—") +
                          " "
                      ),
                    ]),
                    _c("p", { staticClass: "wkb-edge-provenance-line" }, [
                      _c("strong", [_vm._v("Raw score:")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatValue(
                              _vm.payload.factor_relevance?.raw_score,
                              3
                            )
                          ) +
                          " "
                      ),
                    ]),
                    _c("p", { staticClass: "wkb-edge-provenance-line" }, [
                      _c("strong", [_vm._v("Normalized score:")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatValue(
                              _vm.payload.factor_relevance?.normalized_score,
                              3
                            )
                          ) +
                          " "
                      ),
                    ]),
                    _c("WorkspaceEvidenceTable", {
                      attrs: {
                        title: "Top factor genes",
                        rows: _vm.payload.top_factor_genes || [],
                        columns: _vm.topFactorGeneColumns,
                        "pagination-label": "Factor gene pages",
                      },
                    }),
                    _c("WorkspaceEvidenceTable", {
                      attrs: {
                        title: "Top factor gene sets",
                        rows: _vm.payload.top_factor_gene_sets || [],
                        columns: _vm.topFactorGeneSetColumns,
                        "pagination-label": "Factor gene set pages",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "addGeneSet",
                          fn: function ({ row }) {
                            return [
                              _vm.isGeneSetOnGraph(row)
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "wkb-inspector-mini-btn wkb-inspector-mini-btn--remove",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.graphBusy,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onRemoveGeneSet(row)
                                        },
                                      },
                                    },
                                    [_vm._v(" Remove ")]
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass:
                                        "wkb-inspector-mini-btn wkb-inspector-mini-btn--add",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.graphBusy,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onAddGeneSet(row)
                                        },
                                      },
                                    },
                                    [_vm._v(" Add ")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("WorkspaceEvidenceTable", {
                      attrs: {
                        title: "Trait support for top factor genes",
                        rows: _vm.payload.trait_gene_support || [],
                        columns: _vm.traitGeneSupportColumns,
                        "pagination-label": "Trait gene support pages",
                      },
                    }),
                    _c("WorkspaceEvidenceTable", {
                      attrs: {
                        title: "Trait support for top factor gene sets",
                        rows: _vm.payload.trait_gene_set_support || [],
                        columns: _vm.traitGeneSetSupportColumns,
                        "pagination-label": "Trait gene set support pages",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "addGeneSet",
                          fn: function ({ row }) {
                            return [
                              _vm.isGeneSetOnGraph(row)
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "wkb-inspector-mini-btn wkb-inspector-mini-btn--remove",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.graphBusy,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onRemoveGeneSet(row)
                                        },
                                      },
                                    },
                                    [_vm._v(" Remove ")]
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass:
                                        "wkb-inspector-mini-btn wkb-inspector-mini-btn--add",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.graphBusy,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onAddGeneSet(row)
                                        },
                                      },
                                    },
                                    [_vm._v(" Add ")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                )
              : _c("section", { staticClass: "wkb-inspector-panel-block" }, [
                  _c("h4", { staticClass: "wkb-inspector-section-heading" }, [
                    _vm._v(_vm._s(_vm.payload.title || "Edge provenance")),
                  ]),
                  _vm.payload.summary
                    ? _c("p", { staticClass: "wkb-inspector-note" }, [
                        _vm._v(_vm._s(_vm.payload.summary)),
                      ])
                    : _vm._e(),
                  _c("p", { staticClass: "wkb-edge-provenance-line" }, [
                    _c("strong", [_vm._v("Family:")]),
                    _vm._v(" " + _vm._s(_vm.payload.family || "—") + " "),
                  ]),
                  _c("p", { staticClass: "wkb-edge-provenance-line" }, [
                    _c("strong", [_vm._v("Raw score:")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.formatValue(_vm.payload.raw_score, 3)) +
                        " "
                    ),
                  ]),
                  _c("p", { staticClass: "wkb-edge-provenance-line" }, [
                    _c("strong", [_vm._v("Normalized score:")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatValue(_vm.payload.normalized_score, 3)
                        ) +
                        " "
                    ),
                  ]),
                  _vm.payload.path_nodes?.length
                    ? _c("p", { staticClass: "wkb-edge-provenance-line" }, [
                        _c("strong", [_vm._v("Path:")]),
                        _vm._v(
                          " " + _vm._s(_vm.payload.path_nodes.join(" → ")) + " "
                        ),
                      ])
                    : _vm._e(),
                  _vm.payload.extra
                    ? _c("pre", { staticClass: "wkb-edge-provenance-json" }, [
                        _vm._v(_vm._s(_vm.formattedExtra)),
                      ])
                    : _vm._e(),
                ]),
          ]
        : _c("p", { staticClass: "wkb-inspector-note" }, [
            _vm._v(
              " Edge summary only. Select a supported edge to load provenance. "
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }